import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FcMoneyTransfer, FcSms, FcOrgUnit,FcManager, FcMultipleSmartphones,FcUpload,FcFaq,FcSimCardChip,FcServices, FcPuzzle, FcClock ,FcMenu} from "react-icons/fc"; 
import { BsChatLeftDots ,BsCashStack} from "react-icons/bs";
import { CgUserList } from "react-icons/cg";
import { FiUsers } from "react-icons/fi";
import HandleCurrentPath from "./HandleCurrentPath";
const MobileHamburger = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);

  }; 
  
    const closeSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const pathname = window.location.pathname;
  
  return (
    <>
     {/* Mobile menu */}

     <aside
                className={`fixed inset-y-0 z-20 flex-shrink-0 w-64 mt-16 overflow-y-auto bg-white dark:bg-gray-800 md:hidden ${isSideMenuOpen ? 'block' : 'hidden'}`}
                onClick={closeSideMenu}
            >
                <div className="py-4 text-gray-500 dark:text-gray-400">
          <Link
            className="ml-6 text-lg font-bold text-gray-800 dark:text-gray-200"
            href="#"
          >
           NPRS
          </Link>
          <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>
          <ul className="mt-6">
          {/* <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/appUsers'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/appUsers'} >
                <FiUsers/>
                <span className="ml-4">Customers </span>
            </Link>
        </li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/dailyUsers'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/dailyUsers'} >
         <CgUserList/>
         <span className="ml-4">Customers Per Day</span>
     </Link>
</li>



<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/deposit'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/deposit'} >
         <FcMoneyTransfer/>
         <span className="ml-4">Deposits </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/winning'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/winning'} >
         <BsCashStack/>
         <span className="ml-4">Winnings </span>
     </Link>
</li> */}

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/interactiveSms'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/interactiveSms'} >
         <FcSms/>
         <span className="ml-4">InteractiveSms </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/smsMessage'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/smsMessage'} >
         <BsChatLeftDots/>
         <span className="ml-4">Bulk Out</span>
     </Link>
</li>   


<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/phonebook'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/phonebook'} >
         <FcMultipleSmartphones/>
         <span className="ml-4">Phonebooks </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/phonebookupload'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/phonebookupload'} >
         <FcUpload/>
         <span className="ml-4">Upload Contacts </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/bulkbroadcast'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/bulkbroadcast'} >
         <FcFaq/>
         <span className="ml-4">Bulkbroadcast </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/senderid'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/senderid'} >
         <FcSimCardChip/>
         <span className="ml-4">Sender ID </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/client'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/client'} >
         <FcManager/>
         <span className="ml-4">Clients </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/sdpService'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/sdpService'} >
         <FcServices/>
         <span className="ml-4">Sdp Services </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/serviceType'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/serviceType'} >
         <FcPuzzle/>
         <span className="ml-4">Service Type </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/subscriptionSchedule'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/subscriptionSchedule'} >
         <FcClock/>
         <span className="ml-4">SubscriptionSchedule </span>
     </Link>
</li>



          </ul>
          </div>

            </aside>
            {/* End mobile Menu */}
    <button
      className={`p-1 mr-5 -ml-1 rounded-md md:hidden focus:outline-none focus:shadow-outline-purple ${isSideMenuOpen ? 'bg-purple-500' : 'bg-transparent'}`}
      onClick={toggleSideMenu}
      aria-label="Menu"
    >

        <FcMenu/>
      {/* <svg
        className="w-6 h-6 text-white"
        aria-hidden="false"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clipRule="evenodd"
        />
      </svg> */}
    </button>
    </>
    
  );
};

export default MobileHamburger;